import { get } from 'lodash';
import Moment from 'moment';

function error({ actionSubmitType }) {
  return {
    event: 'mybLookupError',
    eventAction: 'find reservation',
    eventActionSubtype: actionSubmitType,
    eventLabel: 'PNR_NOT_FOUND',
  };
}

function success({ actionSubmitType, flightItineraryType, storefront, legCollection, frequentFlyerProgram }) {
  const departureAirport = get(legCollection, '[0].segmentsCollection[0].departureAirport', null);
  const arrivalAirport = get(legCollection, '[0].segmentsCollection[0].arrivalAirport', null);
  const departureRoute = `${departureAirport}|${arrivalAirport}`;

  let departureTime = get(legCollection, '[0].estimatedDepartureTime', null);
  departureTime = departureTime ? Moment(departureTime).format('DDMMYYYYHHmm') : departureTime;

  return {
    event: 'mybLookupSuccess',
    eventAction: 'find reservation',
    eventActionSubtype: actionSubmitType,
    returnFlightAvailable: flightItineraryType === 'ROUNDTRIP' || false,
    storeFront: storefront && storefront.split('-')[1] ? storefront.split('-')[1] : storefront,
    departureRoute: departureRoute,
    departureTime: departureTime,
    EmbudoAM: 'MYB',
    ffProgram: actionSubmitType === 'FREQUENT_FLYER' && frequentFlyerProgram ? frequentFlyerProgram : 'NA',
  };
}

export default {
  error,
  success,
};
